import { render, staticRenderFns } from "./AppStore.vue?vue&type=template&id=62da4eb4"
import script from "./AppStore.vue?vue&type=script&lang=ts"
export * from "./AppStore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports